<div class="m-home-page">
    <div class="orderfailed-mockup mb-4">
      <img src="../../assets/images/rooted.png" alt="img">
    </div>
    <div class="text-orderfaild">
      <h4>Rooted device</h4>
      <p>Your device is rooted. For security reasons, this application cannot run on a rooted device.</p>
    </div>
</div>